import { render, staticRenderFns } from "./activityChart.vue?vue&type=template&id=4e56852a&scoped=true&"
import script from "./activityChart.vue?vue&type=script&lang=js&"
export * from "./activityChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56852a",
  null
  
)

export default component.exports